import { ChangeDetectionStrategy, Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { CardBackgroundComponent } from '../../card-background.component';
import { FikaIndexCardStackBackgroundViewModel } from './fika-index-card-stack-background-view-model';
import type { CardData } from '../../../../../../../models/print-cards/card-data';

@Component({
  selector: 'app-fika-index-card-stack-background',
  templateUrl: './fika-index-card-stack-background.component.html',
  styleUrls: ['./fika-index-card-stack-background.component.scss'],
  providers: [FikaIndexCardStackBackgroundViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class FikaIndexCardStackBackgroundComponent extends CardBackgroundComponent {
  constructor(
    public viewModel: FikaIndexCardStackBackgroundViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }

  @Input() override cardBackground: CardData;
}
